/**
 * Copyright 2013-present, Novivia, Inc.
 * All rights reserved.
 */

/**
 * A module helping with the parsing and i18n of URLs
 * @module utilities/formats/url
 */
"use strict";

var _ = require("lodash");
var deprecate = require("depd")("@auex/utilities");
var path = require("path");
var pathToRegexp = require("path-to-regexp");

var FunctionCallError = require("../errors").FunctionCallError;
var MissingParameterError = FunctionCallError.MissingParameterError;

/**
 * Generate a URL string.
 * @param  {string}  url    Raw URL string.
 * @param  {object} params Parameters values of URL.
 * @return {string}        Translated and formated URL string.
 */
function generateUrl(url, params) {
  if (!_.isString(url)) {
    throw new MissingParameterError(null, "Missing mandatory URL string.", "url");
  }

  if (!_.isObject(params)) {
    throw new MissingParameterError(null, "Missing mandatory parameters values of URL", "params");
  }

  var tokens = pathToRegexp.parse(url);

  // Handle absolute and relative URLs
  return _.reduce(tokens, function reduceTokens(fullUrl, token) {
    var urlParts = [];

    if (_.isString(token)) {
      urlParts = _.without(token.split("/"), "");
    } else if (_.isPlainObject(token)) {
      urlParts.push(params.hasOwnProperty(token.name) ? params[token.name] : ":" + token.name);
    }

    return path.join.apply(null, [fullUrl].concat(urlParts));
  }, url.charAt(0) === "/" ? "/" : "");
}

module.exports = deprecate.function(generateUrl, "'url' is deprecated in this module. Please use" + " '@novivia/utilities/formats/url' instead.");


//////////////////
// WEBPACK FOOTER
// /private/var/folders/n9/yczdnstj3wdc9q5tzm6d45c00000gp/T/maison-encans-auex-website/~/@auex/utilities/lib/formats/url.js
// module id = 875
// module chunks = 6